import Vendor from '@models/vendor';

const getDefaultState = () => ({
    vendor: new Vendor(),
    showHidden: false,
});

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        isStatic() {
            return false;
        },
    },
    mutations: {
        setVendor(state, vendor) {
            state.vendor = vendor;
        },
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
        setShowHidden(state, showHidden) {
            state.showHidden = showHidden;
        },
    },
    actions: {
        async refresh({ dispatch, state }) {
            dispatch('getVendor', state.vendor.id);
        },
        async getVendor({ commit }, vendorId) {
            const vendor = await Vendor.with('apTerm').find(vendorId);

            commit('setVendor', vendor);
        },
        async reset({ commit }) {
            commit('resetState');
        },
    },
};
